import * as React from 'react';

import {SelectInline} from 'shells/select-inline/select-inline';

import type {
    UserEmailAddress as SendableEmailAddressFragment,
    SessionUser as SessionUserFragment,
} from 'nutshell-graphql-types';

import styles from './email-selection.module.css';

type Props = {
    user: SessionUserFragment;
    selectedAddress: SendableEmailAddressFragment;
    onChange: (option: SendableEmailAddressFragment) => any;
};

export class EmailFromSelection extends React.PureComponent<Props> {
    // @ts-expect-error
    props: Props;

    render() {
        return (
            <div className={styles['email-selection']}>
                <SelectInline
                    placeholder='Choose an email address to send from…'
                    options={this.props.user.sendableEmailAddresses}
                    value={this.props.selectedAddress}
                    inlineLabel='From'
                    valueKey='id'
                    labelKey='formatted'
                    tokenizedStyle='none'
                    disabled={this.props.user.sendableEmailAddresses.length === 1}
                    onChange={this.props.onChange}
                />
            </div>
        );
    }
}
